import { useFeatureFlagEnabled as useFFEnabled } from 'posthog-js/react'

export type FeatureFlagKey =
  | 'signal-show-even-if-invisible'
  | 'wiz-integration'
  | 'third-party-usage-list-users'
  | 'questionnaire-module-v2'
  | 'artifacts-auto-detect-upload'
  | 'risk-insights'
  | 'onetrust-integration'
  | 'fourth-parties'
  | 'ramp-integration'
  | 'smart-evidence-request-banner'
  | 'agentic-mode-active-all-companies'
  | 'sso-provision-invite'
  | 'crowdstrike-integration'
  | 'discovery-module'
  | 'vendor-attested-status'
  | 'create-control'
  | 'ai-governance'
  | 'outreach-campaigns'
  | 'mcp-oauth'

export const useFeatureFlagEnabled = (featureFlag: FeatureFlagKey) => {
  const isEnabled = useFFEnabled(featureFlag)
  if (isEnabled === undefined) {
    return { isLoading: true, isEnabled: false }
  } else {
    return { isLoading: false, isEnabled }
  }
}
